// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__k7a36","floatingText":"styles_floatingText__d9yZY"};